module.exports = __webpack_public_path__ + "static/scale-model-of-a-christmas-story-house-museum-in-cleveland-ohio-354ddc32637404f8a5ca08a2c538fcf6.png";